import React from "react";
import { Box, Flex, Heading, Link, LinkButton, Span, Text } from "@catchoftheday/cg-components";
import { OnePassHeader } from "@header-app/components/OnePassHeader";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var PopupContent = function PopupContent() {
  return ___EmotionJSX(Flex, {
    width: "400px",
    flexDirection: "column",
    color: "typography.text",
    boxShadow: "0 2px 4px 0 rgba(0,0,0,0.50)",
    bg: "white",
    borderRadius: "16px",
    overflow: "hidden",
    fontFamily: "onePass"
  }, ___EmotionJSX(OnePassHeader, {
    pb: "20px"
  }, ___EmotionJSX(Heading.h3, {
    fontFamily: "inherit",
    fontWeight: "bold",
    m: "0px",
    mb: "10px",
    color: "inherit"
  }, "Deals, meet points"), ___EmotionJSX(Text, {
    m: "0",
    textAlign: "center",
    fontSize: "xs",
    fontWeight: "medium"
  }, "Collect 2 flybuys points per $1 spent with Catch*")), ___EmotionJSX(Box, {
    pb: "20px",
    px: "14px"
  }, ___EmotionJSX(Flex, {
    mt: "10px",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  }, ___EmotionJSX(LinkButton, {
    block: false,
    fontWeight: "semibold",
    sizeVariant: "md",
    variant: "onePassPrimary",
    href: "/rewards/flybuys/link",
    "data-tracking": "header-app-onepass-link-flybuys"
  }, "LINK flybuys")), ___EmotionJSX(Flex, {
    my: "16px",
    alignItems: "center",
    justifyContent: "center"
  }, ___EmotionJSX(Span, {
    fontSize: "xs",
    fontWeight: "bold",
    color: "onePass.primary"
  }, ___EmotionJSX(Link, {
    color: "inherit",
    href: "/flybuys-catch",
    "data-tracking": "header-app-flybuys-learn-more",
    textDecoration: "underline"
  }, "Learn more"))), ___EmotionJSX(Flex, {
    alignItems: "center",
    justifyContent: "center"
  }, ___EmotionJSX(Span, {
    fontSize: "xs",
    fontWeight: "medium",
    color: "textTertiary"
  }, "*Term, conditions and exclusions apply."))));
};